import { useMemo } from "react";
import FormSelect from "../FormSelect";

export const BusinessSheetStatusOptions = [
    // Reports
    { label: "Author Assigned", value: 0 },
    { label: "Auto Release", value: 1 },
    { label: "Await Author", value: 2 },
    { label: "Await Compliance", value: 3 },
    { label: "Await Feedback", value: 4 },
    { label: "Compliant", value: 5 },
    { label: "Draft Report", value: 6 },
    { label: "Finished", value: 7 },
    { label: "Rejected", value: 8 },
    { label: "Await Further Compliance", value: 9 },
    { label: "Cancelled", value: 10 },
    { label: "Compliance Assigned", value: 11 },
    { label: "Compliant FRN", value: 12 },
    { label: "Execution Only", value: 13 },
    { label: "Follow Up", value: 14 },
    { label: "Give Feedback", value: 15 },
    { label: "Migrate Recommendations", value: 16 },
    { label: "Sent to Client", value: 17 },
    { label: "Compliance Locked", value: 18 },
    { label: "Drafting", value: 19 },

    // Head Office
    { label: "Issue Report", value: 20 },
    { label: "Await Approval", value: 21 },
    { label: "Adviser to Chase", value: 22 },
    { label: "On Hold", value: 23 },
    { label: "Administration", value: 24 },
    { label: "Close Loop", value: 25 },
    { label: "Not Taken Up", value: 26 },
    { label: "Action Required", value: 27 },
    { label: "Approval Received", value: 28 }
];

const BusinessSheetStatusSelect = ({ headOfficeOnly = false, ...props }) => {
    const options = useMemo(() => headOfficeOnly
        ? BusinessSheetStatusOptions.filter(opt => opt.value >= 20)
        : BusinessSheetStatusOptions,
        [headOfficeOnly]);

    return <FormSelect
        {...props}
        options={options}
    />
}

export default BusinessSheetStatusSelect;